import {
  DefaultDashStyle,
  DefaultSizeStyle,
  getUserPreferences,
  setUserPreferences,
  type TldrawOptions,
  type TLUiOverrides,
} from "tldraw";

/**
 * Shared editor options for every tldraw surface. Module-level so the
 * reference is stable — the notepad remounts its editor, and a fresh object
 * each render would churn the options on every mount.
 *
 * `spacebarPanning` is off because the space bar now locks the canvas into a
 * pen-down state; left on, holding space would pan instead of draw.
 */
export const CANVAS_OPTIONS: Partial<TldrawOptions> = {
  spacebarPanning: false,
};

// Ink defaults, set here rather than in an onMount because each surface
// mounts its own <Tldraw> and an onMount reaches only its own editor. Every
// writable mount imports this module — canvasOptionsCoverage.test enforces
// that, exempting only the read-only surfaces, which take their styles from
// the shapes they load and so need no defaults.
//
// `m` is also tldraw's own default: the call pins the value so a version bump
// cannot change our stroke weight silently.
DefaultSizeStyle.setDefaultValue("m");
// `solid` sets thinning to 0, keeping stroke width constant instead of
// varying it with hand speed. Dash is one app-wide style shared by ink, geo,
// arrow and line shapes, so this is deliberately global: shapes drawn on a
// Space get a clean outline, matching the ink.
DefaultDashStyle.setDefaultValue("solid");

// Clear any unsupported theme saved by an earlier version of the app.
setUserPreferences({ ...getUserPreferences(), colorScheme: "light" });

export const CANVAS_COMPONENTS = { MainMenu: null };

export const CANVAS_UI_OVERRIDES: TLUiOverrides = {
  actions(_editor, actions) {
    delete actions["toggle-dark-mode"];
    return actions;
  },
};
